export default __webpack_public_path__ + "static/media/pic1.033714c4.jpg";